import React, { memo } from 'react'
import useFetch from '@alobato/use-fetch'
import CircularProgress from '@alobato/circular-progress'
import { Formik } from 'formik'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'
import useCatalogos from '../../hooks/useCatalogos'
import { enviarCadastro } from '../../lib/enviarCadastro'
import validationSchema from './validationSchema'

import AUTH_TOKEN from '../../constants/authToken'
import BASE_API from '../../constants/baseApi'
import { valorDeGenero } from '../../constants/genero'

const Edit = memo(({ id, data, onRequestClose, onUpdated, especialidades, planos, clinicas }) => {
  /* Tudo entra com valor definido: campo que começa `undefined` e depois
     recebe texto faz o React trocar de input não-controlado para controlado, e
     o console enche de aviso. */
  const initialValues = {
    name: data.name || '',
    login: data.login || '',
    password: '',
    phone: data.phone || '',
    birth_date: data.birth_date || '',
    gender: valorDeGenero(data.gender),
    price: data.price || '',
    description: data.description || '',
    crm: data.crm || '',
    crm_uf: data.crm_uf || '',
    crm_secondary: data.crm_secondary || '',
    crm_secondary_uf: data.crm_secondary_uf || '',
    specialty_primary: data.specialty_primary || '',
    specialty_secondary: data.specialty_secondary || '',
    health_insurances: data.health_insurances || [],
    establishments: data.establishments || []
  }

  const handleSubmit = async (values, actions) => {
    const salvou = await enviarCadastro({
      url: `${BASE_API}/doctor?id=${id}`, method: 'PUT', values, actions
    })
    if (!salvou) return
    onUpdated()
    onRequestClose()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      render={props => (
        <FormModal title='Editar Médico' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} especialidades={especialidades} planos={planos} clinicas={clinicas} />
        </FormModal>
      )}
    />
  )
})

export default memo(props => {
  const { data, error, loading } = useFetch(
    `${BASE_API}/doctor?id=${props.id}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}` } }
  )
  const catalogos = useCatalogos({ clinicas: true })

  if (error) return `Erro! ${error.message}`
  if (!data || loading || catalogos.carregando) {
    return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  }
  return (
    <Edit
      {...props}
      data={data}
      especialidades={catalogos.especialidades}
      planos={catalogos.planos}
      clinicas={catalogos.clinicas}
    />
  )
})
